import type { AddFieldSlot } from '@cli-types/core-engine/add-field.js'

export function normalizeAddFieldSlot(slot: string | undefined): AddFieldSlot | undefined {
  if (slot === undefined) {
    return undefined
  }

  if (slot === 'main' || slot === 'sidebar') {
    return slot
  }

  throw new Error(`Invalid --slot "${slot}". Use "main" or "sidebar".`)
}
